import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};

  & > .hefesto-side-sheet {
    height: 100vh;
    z-index: 2;
    .hefesto-side-sheet-container__close-btn {
      align-self: center;
    }

    aside.hefesto-side-sheet-container .hefesto-side-sheet-container__content {
      height: 85%;
      padding-top: 0;
      position: relative;
    }

    aside.hefesto-side-sheet-container
      header.hefesto-side-sheet-container__header
      h4.hefesto-side-sheet-container__title {
      font-weight: 600;
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.grayDark3};
    }

    aside.hefesto-side-sheet-container
      header.hefesto-side-sheet-container__header {
      z-index: 3;

      position: fixed;
      right: 0;

      justify-content: end;
      padding: 1.5rem 1rem;
    }

    & > .hefesto-side-sheet-container {
      width: 24.375rem;
    }
  }
`;

export const SideSheetContainer = styled.div`
  padding: 1rem 0 1rem 0;

  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const Text = styled.span`
  margin-bottom: 0.5rem;
`;

export const DownloadText = styled.a`
  color: ${({ theme }) => theme.colors.blue6};
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 400;
  font-size: 1rem;
  text-decoration-line: underline;
`;

export const TextTable = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 1.5rem;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ProductTable = styled.div`
  display: grid;
  column-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
`;

export const ModalOverlay = styled.div<{ width: number }>`
  .hefesto-modal__container {
    width: ${({ width }) => (width ? width : 0)}px;
  }
  .hefesto-modal__header {
    margin-bottom: 1rem;
    h3 {
      margin-bottom: 0;
      font-size: 24px;
      line-height: 28px;
      color: ${({ theme }) => theme.colors.grayDark3};
      font-weight: 600;
    }
  }
  .hefesto-modal__body {
    color: #414e55;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1rem;
  & > h3 {
    font-weight: bold;
    margin-bottom: 2rem;
    font-size: 1rem;
  }
  .subtitle {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
  .mdc-chip--selected {
    cursor: default;
    pointer-events: none;
  }
`;

export const CheckBoxContainer = styled.div`
  padding-left: 0.5rem;
  display: flex;
  flex-direction: column;

  gap: 6px;
`;

export const Title = styled.span<{ bold?: boolean; isTitle?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;
